import { RolesSharedService } from '@app/feature/main/roles-shared/services/roles-shared.service';
import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { TechDomainService } from "@app/shared/services/tech-domain.service";
import { Subscription } from "rxjs/Subscription";
@Component({
  selector: 'app-tech-domains-list',
  templateUrl: './tech-domains-list.component.html',
  styleUrls: ['./tech-domains-list.component.css']
})
export class TechDomainsListComponent implements OnInit, OnDestroy {
  techDomainData;
  searchString = "";
  selectedTechDomainId: string;
  subscription: Subscription;
  constructor
    (
    public rolesSharedService: RolesSharedService,
    private router: Router,
    @Inject(DOCUMENT) private document: Document,
    private techDomainService: TechDomainService) {
    this.document.body.classList.add('inner-page');
    this.document.body.classList.remove('outer-page');
  }

  ngOnInit() {
    this.getTechDomainList();
    this.selectedTechDomainId = window.localStorage.getItem('selectedTechDomainId') ?
      window.localStorage.getItem('selectedTechDomainId') : null;

    this.subscription = this.techDomainService.selectedDomainId.subscribe(
      (newSelectedIds) => {
        this.selectedTechDomainId = newSelectedIds;
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }


  techDomainChanged(techDomain) {
    if (this.selectedTechDomainId && this.selectedTechDomainId === techDomain.id) {
      this.selectedTechDomainId = null;
      window.localStorage.removeItem('selectedTechDomainId');
    } else {
      this.selectedTechDomainId = techDomain.id;
      this.techDomainService.setCurrentSelectedIds(techDomain.id);
     // window.localStorage.setItem('selectedTechDomainId', this.selectedTechDomainId);
      this.router.navigate(['']);
    }
  }

  getTechDomainList() {
    this.rolesSharedService.getTechDomainsList().subscribe((techDomainResponse: any) => {
      this.techDomainData = techDomainResponse;
      window.scroll(0, 0);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/tech-domains-list/tech-domains-list.component.ts